import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-modal';
import { getTranslations } from '../../../services/languageUtils';
import Captcha from '../../../components/Captcha';

Modal.setAppElement('#root');

class DocumentsSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            imgModal: '',
            typeModal: '',
            showCameraModal: false,
            cameraStream: null,
            fileNames: {
                socialContract: '',
                balance: '',
                proofAddress: '',
                documentRepresentative: '',
                selfieRepresentative: '',
                ir: '',
                kyc: '',
                partnerProofAddress: '',
                cnpjCard: ''
            },
            translations: {}
        };
        this.videoRef = React.createRef();
    }

    loadTranslations = async () => {
        const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
        this.setState({ translations });
    };

    componentDidMount() {
        this.loadTranslations();
    }

    convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    openModal = (event, type) => {
        const file = event.target.files[0];
        if (!file) return;

        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = (oFREvent) => {
            this.setState({
                modalIsOpen: true,
                imgModal: oFREvent.target.result,
                typeModal: type
            });
        };
    };

    closeModal = () => {
        this.setState({
            modalIsOpen: false,
            imgModal: '',
            typeModal: ''
        });
    };

    confirmUpload = async () => {
        const { typeModal, imgModal } = this.state;

        this.props.onChange(typeModal, imgModal);

        this.setState({
            fileNames: {
                ...this.state.fileNames,
                [typeModal]: `${typeModal}_uploaded.jpg`
            }
        });

        this.closeModal();
        toast.success('Documento enviado com sucesso!');
    };

    handleFileUpload = async (event, documentType) => {
        const file = event.target.files[0];

        if (!file) return;

        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
        if (!allowedTypes.includes(file.type)) {
            toast.error('Tipo de arquivo não permitido. Use apenas JPG, PNG ou PDF.');
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            toast.error('Arquivo muito grande. Tamanho máximo: 5MB.');
            return;
        }

        try {
            if (file.type.startsWith('image/')) {
                this.openModal(event, documentType);
            } else {
                const base64 = await this.convertToBase64(file);
                this.props.onChange(documentType, base64);

                this.setState({
                    fileNames: {
                        ...this.state.fileNames,
                        [documentType]: file.name
                    }
                });

                toast.success('Documento enviado com sucesso!');
            }
        } catch (error) {
            console.error('Erro ao processar arquivo:', error);
            toast.error('Erro ao processar arquivo. Tente novamente.');
        }
    };

    removeDocument = (documentType) => {
        this.props.onChange(documentType, '');
        this.setState({
            fileNames: {
                ...this.state.fileNames,
                [documentType]: ''
            }
        });
        toast.info('Documento removido.');
    };

    handleBack = () => {
        this.props.onBack();
    };

    handleSubmit = () => {
        this.props.onSubmit();
    };

    openCamera = async (documentType) => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ 
                video: { facingMode: 'user' }, 
                audio: false 
            });
            this.setState({
                showCameraModal: true,
                cameraStream: stream,
                typeModal: documentType
            });
            
            if (this.videoRef.current) {
                this.videoRef.current.srcObject = stream;
            }
        } catch (error) {
            console.error('Erro ao acessar a câmera:', error);
            toast.error('Não foi possível acessar a câmera. Verifique as permissões.');
        }
    };

    capturePhoto = () => {
        const video = this.videoRef.current;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx.drawImage(video, 0, 0);
        
        const dataURL = canvas.toDataURL('image/jpeg', 0.8);
        
        this.setState({
            imgModal: dataURL,
            modalIsOpen: true,
            showCameraModal: false
        });
        
        this.stopCamera();
    };

    stopCamera = () => {
        const { cameraStream } = this.state;
        if (cameraStream) {
            cameraStream.getTracks().forEach(track => track.stop());
            this.setState({ cameraStream: null, showCameraModal: false });
        }
    };

    closeCameraModal = () => {
        this.stopCamera();
    };

    render() {
        const { documents, errors, isLoading, captchaToken, captchaKey, onCaptchaVerify } = this.props;
        const { modalIsOpen, imgModal, fileNames, translations } = this.state;

        const documentTypes = [
            { key: 'socialContract', label: 'Contrato Social', description: 'Documento que comprova a constituição da empresa' },
            { key: 'balance', label: 'Balanço dos Últimos 12 Meses', description: 'Demonstrativo financeiro dos últimos 12 meses' },
            { key: 'proofAddress', label: 'Comprovante de Endereço Comercial (úlitmos três meses)', description: 'Conta de luz, água ou telefone (máximo 3 meses)' },
            { key: 'documentRepresentative', label: 'Documento do Representante (apenas o documento aberto ou frente e verso. RG possui validade de 10 anos)', description: 'RG ou CNH do representante legal' },
            { key: 'selfieRepresentative', label: 'Selfie do Representante (apenas foto do representante(s) legal(is) em fundo claro sem o documento)', description: 'Foto do representante segurando o documento' },
            { key: 'ir', label: 'Comprovante de renda do sócio', description: 'Arquivo de IR' },
            { key: 'kyc', label: 'Documento Políticas de PLD/AML assinado', description: '' },
            { key: 'partnerProofAddress', label: 'Comprovante de endereço dos sócios', description: '' },
            { key: 'cnpjCard', label: 'Cartão CNPJ', description: '' },
        ];

        return (
            <div className="sideRightContent">
                <ToastContainer />
                <div className="textContentSteps">
                    <div className="h1">
                        <div className="h1Label">
                            <img src={require("../../../assets/imgs/ico-higher-titulo.svg").default} alt="Logo Higher" className="titleImage"/>
                        </div>
                        <div className="h1LabelMobile">
                            3
                        </div>
                        Documentos
                    </div>
                    <br/>

                    <p className="h5">Envie os documentos necessários para finalizar o cadastro</p>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                        gap: '25px',
                        marginBottom: '30px'
                    }}>
                        {documentTypes.map((docType, index) => (
                            <div key={docType.key} className="contentInputText" style={{ 
                                marginBottom: '0',
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%'
                            }}>
                                <p className="label">{docType.label} *</p>
                                <p style={{ 
                                    margin: '5px 0 15px', 
                                    color: '#6c757d', 
                                    fontSize: '14px',
                                    flex: '0 0 auto'
                                }}>
                                    {docType.description}
                                </p>

                                {!documents[docType.key] ? (
                                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                        <input
                                            type="file"
                                            id={`file-${docType.key}`}
                                            accept="image/*,.pdf"
                                            onChange={(e) => this.handleFileUpload(e, docType.key)}
                                            style={{ display: 'none' }}
                                        />
                                        <label
                                            htmlFor={`file-${docType.key}`}
                                            className={`input ${errors[docType.key] ? "inputDanger" : ""}`}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                textAlign: 'center',
                                                padding: '30px 20px',
                                                backgroundColor: '#f8f9fa',
                                                border: errors[docType.key] ? '2px dashed #FF460C' : '2px dashed #EBEBED',
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease',
                                                minHeight: '160px',
                                                flex: '1'
                                            }}
                                            onMouseOver={(e) => {
                                                if (!errors[docType.key]) {
                                                    e.currentTarget.style.backgroundColor = '#e9ecef';
                                                    e.currentTarget.style.borderColor = '#007bff';
                                                }
                                            }}
                                            onMouseOut={(e) => {
                                                if (!errors[docType.key]) {
                                                    e.currentTarget.style.backgroundColor = '#f8f9fa';
                                                    e.currentTarget.style.borderColor = '#EBEBED';
                                                }
                                            }}
                                        >
                                            <div style={{ fontSize: '48px', color: '#6c757d', marginBottom: '10px' }}>
                                                📁
                                            </div>
                                            <p style={{ margin: 0, color: '#6c757d', fontSize: '14px' }}>
                                                Clique para selecionar ou arraste o arquivo aqui
                                            </p>
                                            <p style={{ margin: '5px 0 0', color: '#6c757d', fontSize: '12px' }}>
                                                Formatos aceitos: JPG, PNG, PDF (máx. 5MB)
                                            </p>
                                        </label>
                                        
                                        <button
                                            type="button"
                                            onClick={() => this.openCamera(docType.key)}
                                            style={{
                                                marginTop: '10px',
                                                padding: '10px 15px',
                                                backgroundColor: '#007bff',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '8px',
                                                transition: 'background-color 0.3s ease'
                                            }}
                                            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                                            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                                        >
                                            Usar Câmera
                                        </button>
                                    </div>
                                ) : (
                                    <div className="input" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: '15px',
                                        padding: '15px',
                                        backgroundColor: '#e8f5e8',
                                        border: '2px solid #28a745',
                                        borderRadius: '8px',
                                        flex: '1'
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <div style={{ fontSize: '24px' }}>📄</div>
                                            <div>
                                                <p style={{ margin: 0, fontWeight: 'bold', color: '#155724' }}>
                                                    {fileNames[docType.key] || `${docType.label} enviado`}
                                                </p>
                                                <p style={{ margin: '5px 0 0', fontSize: '12px', color: '#6c757d' }}>
                                                    Documento enviado com sucesso
                                                </p>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <span style={{
                                                backgroundColor: '#28a745',
                                                color: 'white',
                                                padding: '4px 8px',
                                                borderRadius: '12px',
                                                fontSize: '12px',
                                                fontWeight: 'bold'
                                            }}>
                                                ✓ Enviado
                                            </span>
                                            <button
                                                type="button"
                                                onClick={() => this.removeDocument(docType.key)}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: '#dc3545',
                                                    cursor: 'pointer',
                                                    fontSize: '18px',
                                                    padding: '0',
                                                    width: '20px',
                                                    height: '20px'
                                                }}
                                                title="Remover documento"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {errors[docType.key] && (
                                    <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>
                                        {errors[docType.key]}
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>

                    <div style={{
                        marginTop: '20px',
                        padding: '15px',
                        backgroundColor: '#fff3cd',
                        borderRadius: '8px',
                        border: '1px solid #ffeaa7',
                        marginBottom: '30px'
                    }}>
                        <p style={{
                            margin: 0,
                            fontSize: '14px',
                            color: '#856404',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <span style={{ fontSize: '16px' }}>⚠️</span>
                            Certifique-se de que todos os documentos estão legíveis e dentro da validade<br/>
                        </p>
                    </div>

                    <div style={{
                        marginTop: '20px',
                        padding: '15px',
                        backgroundColor: '#fff3cd',
                        borderRadius: '8px',
                        border: '1px solid #ffeaa7',
                        marginBottom: '30px'
                    }}>
                        <p style={{
                            margin: 0,
                            fontSize: '14px',
                            color: '#856404',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <span style={{ fontSize: '16px' }}>⚠️</span>
                            Todos os documentos que requerem assinatura precisam ser assinados via certificado digital (ICP-Brasil)
                        </p>
                    </div>

                    <Captcha
                        key={captchaKey}
                        disabled={isLoading}
                        onVerify={onCaptchaVerify}
                    />

                    <div className="lineBtnSaveAndContinue">
                        <div
                            className="btnSaveAndContinue"
                            onClick={!isLoading ? this.handleBack : undefined}
                            style={{
                                opacity: isLoading ? 0.6 : 1,
                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                width: '150px',
                                backgroundColor: '#6c757d',
                                borderColor: '#6c757d'
                            }}
                        >
                            {isLoading ? 'Carregando...' : 'Voltar'}
                        </div>
                        <div
                            className="btnSaveAndContinue"
                            onClick={!isLoading && captchaToken ? this.handleSubmit : undefined}
                            style={{
                                opacity: isLoading || !captchaToken ? 0.6 : 1,
                                cursor: isLoading || !captchaToken ? 'not-allowed' : 'pointer',
                                width: '300px'
                            }}
                        >
                            {isLoading ? 'Finalizando...' : 'Finalizar Cadastro'}
                            {!isLoading && (
                                <div className="arrow">
                                    <img 
                                        src={require("../../../assets/imgs/seta-right-branca.svg").default} 
                                        alt="Finalizar" 
                                        className="arrowNext"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <Modal
                    isOpen={this.state.showCameraModal}
                    onRequestClose={this.closeCameraModal}
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0.75)',
                            zIndex: 1000
                        },
                        content: {
                            top: '50%',
                            left: '50%',
                            right: 'auto',
                            bottom: 'auto',
                            marginRight: '-50%',
                            transform: 'translate(-50%, -50%)',
                            maxWidth: '90%',
                            maxHeight: '90%',
                            padding: '20px'
                        }
                    }}
                >
                    <div style={{ textAlign: 'center' }}>
                        <h3 style={{ marginBottom: '20px' }}>Capturar Foto</h3>
                        <video
                            ref={this.videoRef}
                            autoPlay
                            style={{
                                width: '100%',
                                maxWidth: '400px',
                                height: '300px',
                                borderRadius: '8px',
                                marginBottom: '20px',
                                backgroundColor: '#000'
                            }}
                        />
                        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
                            <button
                                onClick={this.closeCameraModal}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer'
                                }}
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={this.capturePhoto}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer'
                                }}
                            >
                                Capturar
                            </button>
                        </div>
                    </div>
                </Modal>

                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={this.closeModal}
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0.75)',
                            zIndex: 1000
                        },
                        content: {
                            top: '50%',
                            left: '50%',
                            right: 'auto',
                            bottom: 'auto',
                            marginRight: '-50%',
                            transform: 'translate(-50%, -50%)',
                            maxWidth: '90%',
                            maxHeight: '90%',
                            padding: '20px'
                        }
                    }}
                >
                    <div style={{ textAlign: 'center' }}>
                        <h3 style={{ marginBottom: '20px' }}>Preview do Documento</h3>
                        {imgModal && (
                            <img
                                src={imgModal}
                                alt="Preview"
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '400px',
                                    borderRadius: '8px',
                                    marginBottom: '20px'
                                }}
                            />
                        )}
                        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
                            <button
                                onClick={this.closeModal}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer'
                                }}
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={this.confirmUpload}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer'
                                }}
                            >
                                Confirmar Upload
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default DocumentsSection;